var _defs, _use, _use2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgModerateRain(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "c",
    viewBox: "0 0 193 193"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 96.5,
    cy: 96.5,
    r: 40,
    fill: "none",
    stroke: "#0F172A",
    strokeMiterlimit: 10,
    strokeWidth: 9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 9,
    d: "M96.5 29.9V4.5m0 184v-25.4m47.1-113.7 18-18M31.4 161.6l18-18m0-94.2-18-18m130.2 130.2-18-18M4.5 96.5h25.4m158.6 0h-25.4"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    additive: "sum",
    attributeName: "transform",
    dur: "6s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 96.5 96.5; 45 96.5 96.5"
  }))), /*#__PURE__*/React.createElement("symbol", {
    id: "d",
    viewBox: "0 0 359 231"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0F172A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 15,
    d: "M295.5 223.5a56 56 0 000-112l-2.5.1a83.9 83.9 0 00-153-64.2 56 56 0 00-84.6 48.1 56.6 56.6 0 00.8 9 60 60 0 0011.2 119"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "b",
    viewBox: "0 0 435.5 371.5"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: 193,
    height: 193,
    transform: "translate(69.5 110.5)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: 359,
    height: 231,
    transform: "translate(76.5 140.5)"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "e",
    overflow: "visible",
    viewBox: "0 0 128 56"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0F172A",
    d: "M8 56a8 8 0 01-8-8V8a8 8 0 0116 0v40a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x1",
    additive: "sum",
    attributeName: "transform",
    begin: "0s; x1.end+.33s",
    dur: ".67s",
    type: "translate",
    values: "0 -60; 0 60"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y1",
    attributeName: "opacity",
    begin: "0s; y1.end+.33s",
    dur: ".67s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F172A",
    d: "M64 56a8 8 0 01-8-8V8a8 8 0 0116 0v40a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x2",
    additive: "sum",
    attributeName: "transform",
    begin: ".33s; x2.end+.33s",
    dur: ".67s",
    type: "translate",
    values: "0 -60; 0 60"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y2",
    attributeName: "opacity",
    begin: ".33s; y2.end+.33s",
    dur: ".67s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0F172A",
    d: "M120 56a8 8 0 01-8-8V8a8 8 0 0116 0v40a8 8 0 01-8 8Z",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animateTransform", {
    id: "x3",
    additive: "sum",
    attributeName: "transform",
    begin: "-.33s; x3.end+.33s",
    dur: ".67s",
    type: "translate",
    values: "0 -60; 0 60"
  }), /*#__PURE__*/React.createElement("animate", {
    id: "y3",
    attributeName: "opacity",
    begin: "-.33s; y3.end+.33s",
    dur: ".67s",
    keyTimes: "0; .25; 1",
    values: "0; 1; 0"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M288 148a83.8 83.8 0 00-71.4 40 56 56 0 00-84.6 48 56.6 56.6 0 00.8 9A60 60 0 0084 304H0V0h288Z"
  })))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: 435.5,
    height: 371.5
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    width: 128,
    height: 56,
    transform: "translate(192 344)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModerateRain);
export default __webpack_public_path__ + "static/media/Moderate Rain.87b0be3878586c91014020794121210c.svg";
export { ForwardRef as ReactComponent };